module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selector"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('div', {
    staticClass: "select is-medium",
    staticStyle: {
      "margin-bottom": "7px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentParty),
      expression: "currentParty"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentParty = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.parties), function(party) {
    return _c('option', {
      domProps: {
        "value": party.name
      }
    }, [_vm._v("\n            " + _vm._s(party.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.partyLogo,
      "width": "20px;",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "versionselect clearfix"
  }, [(_vm.loading) ? _c('p', [_vm._v("Loading")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.versions), function(version) {
    return _c('a', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "navbar-item",
      class: {
        'is-active': _vm.isCurrentVersion(version)
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentVersion(version)
        }
      }
    }, [_c('img', {
      staticClass: "image-version",
      attrs: {
        "data-src": _vm.getImageLink(version)
      }
    })])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c357bebe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selector.vue
// module id = 231
// module chunks = 1